<template lang="pug">
  BaseForm(
    :title="title"
    :routeKey="routeKey"
    :routes="routes"
    :form="form"
    :data="item"
    :update="updateItem"
    :create="createItem"
  )
</template>

<script>
import BaseForm from '@/components/app/BaseForm'
import { mapState, mapActions } from 'vuex'
import store from '@/store'

export default {
  components: { BaseForm },
  data: (vm) => ({
    title: vm.$t('riders.disciplines.edit', { id: vm.$route.params.disciplineId })
  }),
  computed: {
    ...mapState('ridersDisciplines', ['routeKey', 'routes', 'form', 'item']),
    crumbs: vm => [
      { text: vm.$t('riders.title'), to: { name: 'riders.index' } },
      { text: vm.$t('riders.disciplines.title'), to: { name: 'riders.disciplines.index' } },
      { text: vm.$t('riders.disciplines.edit', { id: vm.$route.params.disciplineId }) }
    ]
  },
  async beforeRouteEnter (to, from, next) {
    try {
      await store.dispatch('ridersDisciplines/fetchItem', { route: to })
      next()
    } catch (error) {
      next(error)
    }
  },
  methods: {
    ...mapActions('ridersDisciplines', ['createItem', 'updateItem'])
  }
}
</script>
